import React from "react";
import "./servicecard.css";

const serviceData = [
  {
    point: "POINT 01",
    title: "新規商品登録〜ページ作成",
    desc: "商品の良さを分かりに伝え、魅力的な画像やテキストで商品価値を徹底訴求（社内にいない方がプロでご提供。クリック率・転換率向上させ、売上アップを図ります。",
    img: "https://i.ibb.co/8nTJ5Sf8/shinki.png", // 適当なSVG
  },
  {
    point: "POINT 02",
    title: "SEO対策運用",
    desc: "Amazon・Rakuten売上アップに欠かせないSEO対策を独自の戦略で徹底的に強化し、ロングヒットを生み出すノウハウでベストセラー獲得を目指します。",
    img: "https://i.ibb.co/ks3qKdQJ/seo.png",
  },
  {
    point: "POINT 03",
    title: "タイムセール運用",
    desc: "AmazonジャパンもしくはRakutenの担当者と連絡をとり、セールの実施伝え、この商品をどのくらいの価格帯等を事前考え売上が最大化するのかを検討いたします。",
    img: "https://i.ibb.co/mVmCcZ8Z/timesale.png",
  },
  {
    point: "POINT 04",
    title: "プロモーション＆レビュー施策実行",
    desc: "クーポン・プライム会員限定割引・Vineレビュー等、貴社の状況に合わせて最適なプロモーションを実施いたします。最短で最大の売上アップを実現できます。",
    img: "https://i.ibb.co/hJgH8qNp/promotion.png",
  },
  {
    point: "POINT 05",
    title: "売上分析＆効果測定",
    desc: "日々の売上推移やユーザーのデータを分析し、月1回の詳細な報告書でAmazon・Rakuten広告費換算でのコンサルタント的な的確な戦略を報告いたします。",
    img: "https://i.ibb.co/mFg5CnLG/income.png",
  },
  {
    point: "POINT 06",
    title: "（チャット＆電話）のリアルタイムサポート",
    desc: "Amazon・Rakuten販売では突如エラーなどが発生し緊急対応になることがありますが、私たちはチャットやお電話でリアルタイムでサポートする体制を整えております。",
    img: "https://i.ibb.co/mCQs9QsV/support.png",
  },
];

export default function AmazonService() {
  return (
    <section id="servicescard" className="amz-service-section">
      <div className="amz-service-heading">
        <span className="section-label">WHAT I CAN DO</span>
        <br />
        <span>
          <span className="service-title">Amazon・Rakuten運用代行サービス</span>
        </span>
      </div>
      <div className="amz-service-grid">
        {serviceData.map((item, i) => (
          <div className="amz-service-card" key={i}>
            <img className="card-img" src={item.img} alt={item.title} />
            <div className="card-content">
              <span className="card-point">{item.point}</span>
              <div className="card-title">{item.title}</div>
              <div className="card-desc">{item.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}